import { render } from "./ThumbsDownButton.vue?vue&type=template&id=7046c8f3"
import script from "./ThumbsDownButton.vue?vue&type=script&lang=js"
export * from "./ThumbsDownButton.vue?vue&type=script&lang=js"
script.render = render

export default script